import * as types from '../actions';

export default function setScansStatusFilters(statuses) {
  return {
    type: types.SET_SCANS_STATUS_FILTERS,
    statuses,
  };
}
